<template>
    <div>
        <br/>
        <nav class="navbar navbar-expand-lg navbar-light" v-if="canViewDriverAll || canViewPurchases">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <input v-model="search.driver_name"
                            class="form-control mr-sm-2"
                            type="search"
                            placeholder="ชื่อคนขับ"
                            aria-label="Search"/>
                    <input v-model="search.license_plate"
                            class="form-control mr-sm-2"
                            type="search"
                            placeholder="ทะเบียนรถ"
                            aria-label="Search"/>
                    <b-form-select v-model="search.transport_type"
                                   :options="optionTransport" >
                    </b-form-select>&nbsp
                    <button @click="searchDamages"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp
                    <button @click="showDamagesModal"
                            class="btn btn-warning my-2 my-sm-0"
                            type="button">
                        <icon name="plus"></icon> เพิ่มค่าเสียหาย
                    </button>&nbsp
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">ชื่อ-นามสกุล</th>
                    <th scope="col">ทะเบียนรถ</th>
                    <th scope="col">ยอดเสียหาย</th>
                    <th scope="col">ยอดเงินสะสม</th>
                    <th scope="col">ดูข้อมูลการจ่าย</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in driver_damages">
                    <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
                    <td>{{data.name}}</td>
                    <td>{{data.license_plate}}</td>
                    <td>{{data.damages_total | currency }}</td>
                    <td>{{data.damages_cost | currency }}</td>
                    <td>
                        <button @click="showDamagesData(data.id)"
                                class="btn btn-default next">
                            ดูข้อมูล
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="driver_damages.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getDriverPage">
            </vue-pagination>
        </div>
        <br/>
        <!--Modal import repair-->
        <b-modal
                hide-footer
                ref="import_data"
                id="edit"
                title="เพิ่มค่าเสียหาย">
            <div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">
                        <label>คนขับ</label>
                    </div>
                    <div class="col-sm-6">
                        <multiselect
                                :options="optionDriver"
                                label="name"
                                placeholder="กรุณาเลือกคนขับ"
                                v-model="form.driver"
                                @input="setDriverData(form.driver)"
                                :show-labels="false"
                                track-by="name">
                        </multiselect>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">
                        <label>ทะเบียนรถ</label>
                    </div>
                    <div class="col-sm-6">
                        <input class="form-control"
                               placeholder="ทะเบียนรถ"
                               v-model="form.license_plate"
                               :disabled="form.driver"
                               type="text"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">
                        <label>ประเภทรถ</label>
                    </div>
                    <div class="col-sm-6">
                        <b-form-select v-model="form.transport_type_id"
                                       :options="optionTransport">
                        </b-form-select>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">
                        <label>ยอดเสียหาย</label>
                    </div>
                    <div class="col-sm-6">
                        <input class="form-control"
                               placeholder="จำนวนเงิน"
                               v-model="form.damage_cost"
                               type="number"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">
                        <label>หมายเหตุ </label>
                    </div>
                    <div class="col-sm-6">
                        <textarea class="form-control" v-model="form.reason"></textarea>
                    </div>
                </div>
                <br/>
                <div class="col text-center">
                    <button @click="saveDamagesCost"
                            type="button"
                            class="btn btn-success">
                        <icon name="save" style="width: 25px"></icon> บันทึก</button>&nbsp&nbsp
                    <button @click="hideDamagesModal"
                            type="button"
                            class="btn btn-outline-secondary">
                        <icon name="times" style="width: 25px"></icon> ยกเลิก
                    </button>
                </div>
                <br/>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"/>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ optionDriver }}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import Multiselect from "vue-multiselect";
    import moment from "moment";
    import VuePagination from "../../Pagination";
    import {
        canViewDriver,
        canViewDriverAll,
        canViewPurchases,
    } from "../../../util/Permissions";
    import Loading from "../../Utility/Loading";
    export default {
        name: "damages-list",
        components:{
            Loading,
            VuePagination,
            Multiselect},
        data(){
            return {
                form :{
                    transport_type_id : "",
                    driver : null,
                    damages_cost : "",
                    license_plate : "",
                    reason : '',
                },
                search : {
                    driver_name : "",
                    license_plate : "",
                    transport_type : ""
                },
                event_submit : false,
                msg : 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่',
                status_loading : 1,
            }
        },
        created(){
            this.$store.dispatch('Damages/setDamages',1);
            this.$store.dispatch('Driver/getAll');
            this.$store.dispatch("TransportType/setTransportTypes");
        },
        computed:{
            canViewDriver,
            canViewDriverAll,
            canViewPurchases,
            ...mapState({
                driver_damages :state=>{
                    return state.Damages.damages_cost
                },
                optionDriver :state=>{
                    return state.Driver.optionDriver.filter(driver=>!driver.cancel_status);
                },
                user:state=>{
                    return state.Auth.user
                },
                optionTransport:state=>{
                    return [
                        {
                            value: "",
                            text: "เลือกประเภทรถ"
                        },
                        ...state.TransportType.transportTypeList.map(type => ({
                            value: type.id,
                            text: type.name
                        }))
                    ];
                },
                dataPaginate:state=>{
                    return state.Damages.dataPaginate
                }
            })
        },
        methods:{
            showDamagesModal(){
                this.$refs.import_data.show();
            },
            hideDamagesModal(){
                this.$refs.import_data.hide();
            },
            showLoadingModal(){
                this.$refs.loading.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            setDriverData(driver){
                if(driver){
                    this.form.license_plate = driver.license_plate;
                    this.form.transport_type_id = driver.transport_type_id;
                }else{
                    this.form.license_plate = "";
                    this.form.transport_type_id = "";
                }
            },
            saveDamagesCost(){
                const currentDate = moment().format("YYYY-MM-DD");
                if(!this.form.driver){
                    alert('กรุณาเลือกรายชื่อคนขับ')
                }else{
                    const data = {
                        driver_id : this.form.driver.id,
                        damages_cost : this.form.damage_cost,
                        date :  currentDate,
                        recipient : this.user.name,
                        reason : this.form.reason,
                    };
                    this.showLoadingModal();
                    this.msg = 'กำลังบันทึกข้อมูล';
                    this.status_loading = 1;
                    this.$store.dispatch('Damages/saveAmountDamages',data).then(()=>{
                        this.hideDamagesModal();
                        this.hideLoadingModal();
                        this.$store.dispatch('Damages/setDamages',1);
                    }).then(()=>{
                        this.hideLoadingModal();
                        this.form  ={
                            transport_type_id : "",
                            driver : null,
                            damages_cost : "",
                            license_plate : "",
                            reason : '',
                        }
                    }).catch(()=> {
                        this.msg = 'ดาวโหลดข้อมูล กรุณารอสักครู่';
                        this.status_loading = 3;
                    })
                }

            },
            showDamagesData(id){
                if(id){
                    this.showLoadingModal();
                    let page = this.dataPaginate.current_page;
                    this.$store.dispatch('Driver/getDriverById',id)
                        .then(()=>{
                            this.$store.dispatch("Damages/showDamages",{
                                driver_id : id,
                                page : 1,
                            }).then(()=>{
                                let route = this.$router.resolve({
                                    name : "damages-information"
                                });
                                window.open(route.href,'_blank');
                                this.hideLoadingModal();
                                this.getCurrentPage(page);
                            }).catch(()=> {
                                this.msg = 'ดาวโหลดข้อมูล กรุณารอสักครู่';
                                this.status_loading = 3;
                            })
                        }).catch(()=> {
                        this.msg = 'ดาวโหลดข้อมูล กรุณารอสักครู่';
                        this.status_loading = 3;
                    });
                }
            },
            searchDamages(){
                this.event_submit = true;
                this.$store.dispatch('Damages/searchDamages',{
                    search : this.search
                });
            },
            getDriverPage(){
                const page = this.dataPaginate.current_page;
                if(this.event_submit){
                    this.$store.dispatch('Damages/searchDamages',{
                        page : page,
                        search : this.search
                    }).then(()=>{
                        this.search.transport_type = ""
                    })
                }
                else{
                    this.$store.dispatch('Damages/setDamages',page);
                }
            },
            getCurrentPage(page){
                this.$store.dispatch('Damages/setDamages',page);
            },
        }

    }
</script>

<style scoped>

</style>
